import { onViewTransitionCreated } from '@ngspot/view-transition';

export const safeViewTransitionHandler: typeof onViewTransitionCreated = (
  info,
) => {
  try {
    info.transition.finished.catch(() => {});
    info.transition.ready.catch(() => {});
    info.transition.updateCallbackDone.catch(() => {});
    return onViewTransitionCreated(info);
  } catch (_) {
    // ignore transition errors
    return;
  }
};
